function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSix0309(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 845.35 859.18",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("path", {
    d: "M571.53,661.49c1.15,7.88,1.74,15.84,1.75,23.8,.87,84.04-66.55,152.88-150.59,153.76,0,0-.01,0-.02,0-83.05,0-150.52-70.53-150.52-155.42-.02-7.41,.54-14.81,1.66-22.14C125.14,612.57,20.13,492.77,20.13,352.67,20.13,168.9,200.4,20.13,422.68,20.13s402.55,148.77,402.55,332.54c.09,140.1-104.93,259.91-253.69,308.82Z",
    style: {
      fill: "none",
      stroke: "#09d084",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: "40.25px"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 264.63,
    cy: 277.58,
    r: 66.07,
    style: {
      fill: "#09d084"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 580.72,
    cy: 277.58,
    r: 66.07,
    transform: "translate(-26.19 491.93) rotate(-45)",
    style: {
      fill: "#09d084"
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 422.68,
    cy: 508.09,
    r: 84.1,
    style: {
      fill: "#09d084"
    }
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSix0309);
export default __webpack_public_path__ + "static/media/six0309.15c0f0872772b6a95f2edbbd6544b845.svg";
export { ForwardRef as ReactComponent };